import React, { FC, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import EditModal from "./EditModal";
import { ServiceSection } from "../../../../models/manageWebSite";
import { Button } from "primereact/button";
interface Section3Props {
  data: ServiceSection | null;
  flag: boolean;
  setFlag: (flag: boolean) => void;
  homeId: string | null;
}
const Section4: FC<Section3Props> = ({ data, flag, setFlag, homeId }) => {
  const [openModal, setOpenModal] = useState<boolean>(false);

  return (
    <div id="11" style={{ width: "100%", background: "linear-gradient(180deg, #fffaf3 0%, #f8fbff 100%)", padding: "3rem 1.25rem" }} className="scroll-slide-section">
      <div style={{ maxWidth: "1180px", margin: "0 auto" }}>
        <div className="flex flex-wrap align-items-center justify-content-between gap-3 mb-4">
          <div>
            <div style={{ color: "#9a3412", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.12em", fontSize: "0.8rem" }}>
              Services and activities
            </div>
            <div style={{ color: "#0f172a", fontSize: "2rem", fontWeight: 800, marginTop: "0.65rem" }}>
              Care and daily life highlights
            </div>
          </div>
          <Button label="Edit Services" severity="warning" className="website-section-action-button" onClick={() => setOpenModal(true)} />
        </div>

        <div className="grid">
          <div className="col-12 lg:col-6">
            <div style={{ background: "#ffffff", border: "1px solid #d9e8f5", borderRadius: "28px", padding: "1.5rem", boxShadow: "0 20px 40px rgba(15,61,99,0.08)", height: "100%" }}>
              <div style={{ textTransform: "uppercase", fontWeight: 800, fontSize: "0.85rem", letterSpacing: "0.1em", color: "#185da2", marginBottom: "1rem" }}>
                Services
              </div>
              <div style={{ color: "#5f7488", lineHeight: 1.75, marginBottom: "1rem" }}>
                Highlight the care support, hospitality, and daily routines families can expect when they reach out.
              </div>
              <ul style={{ paddingLeft: "1.1rem", margin: 0, color: "#36546c", lineHeight: 1.9 }}>
                {data?.services.map((obj) => (
                  <li key={uuidv4()} className="p-1">{obj}</li>
                ))}
              </ul>
            </div>
          </div>

          <div className="col-12 lg:col-6">
            <div style={{ background: "#ffffff", border: "1px solid #d9e8f5", borderRadius: "28px", padding: "1.5rem", boxShadow: "0 20px 40px rgba(15,61,99,0.08)", height: "100%" }}>
              <div style={{ textTransform: "uppercase", fontWeight: 800, fontSize: "0.85rem", letterSpacing: "0.1em", color: "#b45309", marginBottom: "1rem" }}>
                Activities
              </div>
              <div style={{ color: "#5f7488", lineHeight: 1.75, marginBottom: "1rem" }}>
                Show what life feels like in the home, from engagement and community to comfortable everyday living.
              </div>
              <ul style={{ paddingLeft: "1.1rem", margin: 0, color: "#36546c", lineHeight: 1.9 }}>
                {data?.activities.map((obj) => (
                  <li key={uuidv4()} className="p-1">{obj}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <EditModal isOpen={openModal} toggleModal={setOpenModal} flag={flag} setFlag={setFlag} data={data} homeId={homeId} />
    </div>
  );
};

export default Section4;
